import { Box, Grid } from '@factorialco/deprecated-design-system'
import {
  BenefitsBenefitAvailabilityFragment,
  BenefitsCardBenefitListHealthcarePlanFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  BenefitsCardBenefit,
  BenefitsCardBenefitActions,
  BenefitsCardBenefitSkeleton,
} from 'modules/benefits/components/BenefitsCardBenefit'
import { openModal } from 'modules/benefits/components/benefitModals/actions'
import { useBenefitModals } from 'modules/benefits/components/benefitModals/useBenefitModals'
import { useActiveMarkets } from 'modules/benefits/hooks/useActiveMarkets'
import {
  BenefitListing,
  BenefitSetupStatus,
  getBenefitsList,
} from 'modules/benefits/lib/benefitListings'

interface Props {
  showStatus?: boolean
  featureAvailabilities?: BenefitsBenefitAvailabilityFragment[]
  healthcarePlans: BenefitsCardBenefitListHealthcarePlanFragment[] | undefined
}

const BenefitsCardBenefitList = ({
  showStatus = false,
  featureAvailabilities,
  healthcarePlans,
}: Props) => {
  const activeMarkets = useActiveMarkets()?.activeMarkets

  const benefits = activeMarkets?.flatMap((market) => {
    return getBenefitsList(market, featureAvailabilities)
  })

  const { dispatch } = useBenefitModals()

  function actionsForBenefit(benefit: BenefitListing): BenefitsCardBenefitActions | undefined {
    if (!(benefit.id === 'health_insurance_es' || benefit.id === 'health_insurance_pt')) {
      return undefined
    }

    switch (benefit.id) {
      case 'health_insurance_es':
      case 'health_insurance_pt':
        if (healthcarePlans?.length ?? 0 > 0) {
          return {
            primaryAction: {
              label: i18n.t('benefits.actions.download_plan'),
              onClick: () => {
                window.open(healthcarePlans?.[0]?.planDocument?.url ?? '', '_blank')
              },
            },
          }
        } else {
          return {
            primaryAction: {
              label: i18n.t('benefits.actions.create_plan'),
              onClick: () => dispatch(openModal('healthcare_plan_create')),
            },
          }
        }
    }
  }

  const renderedBenefits = benefits ?? new Array(3).fill(null)

  const setupStatus = (benefit: BenefitListing): BenefitSetupStatus | undefined => {
    if (benefit.id === 'health_insurance_es' || benefit.id === 'health_insurance_pt') {
      if (healthcarePlans?.length ?? 0 > 0) {
        return 'active'
      } else {
        return 'pending_setup'
      }
    }
    return undefined
  }

  return (
    <Box gap="s12" flexDirection="row" flexWrap="wrap">
      <Grid variant="fixed">
        {renderedBenefits.map((benefit, idx) => (
          <Box key={idx} gridColSpan={{ xxs: 12, xs: 12, s: 12, m: 4, l: 4, xl: 3, xxl: 3 }}>
            {benefit ? (
              <BenefitsCardBenefit
                key={benefit.title}
                benefitListing={benefit}
                setupStatus={setupStatus(benefit)}
                showTag={showStatus}
                actions={actionsForBenefit(benefit)}
              />
            ) : (
              <BenefitsCardBenefitSkeleton />
            )}
          </Box>
        ))}
      </Grid>
    </Box>
  )
}

export { BenefitsCardBenefitList }
